const accessControl = {
  // Page meta
  pageTitle: 'Access Control',
  pageSubtitle: 'Manage user accounts, roles, and access permissions across the platform',
  // Stats cards
  totalUsers: 'Total Users',
  activeUsers: 'Active Users',
  pendingUsers: 'Pending Users',
  inactiveUsers: 'Inactive Users',
  // Table
  userName: 'User Name',
  email: 'Email',
  phone: 'Phone',
  role: 'Role',
  lastLogin: 'Last Login',
  created: 'Created',
  noUsersFound: 'No users found matching your search.',
  tryAdjustingFilters: 'Try adjusting your search or filters.',
  usersCount: '{{count}} user',
  usersCountPlural: '{{count}} users',
  // Actions
  createUser: 'Create User',
  editRole: 'Edit Role',
  resendDetails: 'Resend Details',
  sendDetails: 'Send Details',
  changeRole: 'Change Role',
  saveRole: 'Save Role',
  deactivateUser: 'Deactivate User',
  activateUser: 'Activate User',
  // Create User Modal
  createUserTitle: 'Create New User',
  createUserSubtitle: 'Fill in the details to add a new user to the platform',
  userNamePlaceholder: 'Enter full name',
  emailPlaceholder: 'Enter email address',
  phonePlaceholder: '+91 XXXXX XXXXX',
  selectRole: 'Select a role',
  autoGeneratedPassword: 'Auto-generated Password',
  passwordNote: 'A secure password will be auto-generated. You can share the credentials with the user via email.',
  createAndSend: 'Create & Send Details',
  createOnly: 'Create User',
  // Success messages
  userCreated: 'User created successfully!',
  userCreatedAndSent: 'User created and credentials sent via email.',
  roleUpdated: 'Role updated successfully.',
  detailsResent: 'Credentials resent to {{email}}.',
  detailsSent: 'Credentials sent to {{email}}.',
  userDeactivated: 'User has been deactivated.',
  userActivated: 'User has been activated.',
  // Confirm dialogs
  confirmDeactivateTitle: 'Deactivate User?',
  confirmDeactivateMessage: 'This user will lose access to the platform. You can reactivate them later.',
  confirmActivateTitle: 'Activate User?',
  confirmActivateMessage: 'This will restore platform access for this user.',
  confirmResendTitle: 'Resend Credentials?',
  confirmResendMessage: 'A new password will be generated and the credentials will be emailed to {{email}}.',
  // Search & Filter
  searchUsers: 'Search users...',
  filterByRole: 'Filter by Role',
  filterByStatus: 'Filter by Status',
  allRoles: 'All Roles',
  allStatuses: 'All Statuses',
  // Breadcrumbs
  accessControlBreadcrumb: 'Access Control',
};

export default accessControl;